import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "nav-links" }
const _hoisted_5 = {
  key: 0,
  class: "mobile-menu"
}
const _hoisted_6 = { class: "footer" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "footer-content" }

import { ref, onMounted, onUnmounted } from "vue";

import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const menuOpen = ref(false);
const route = useRoute();

const isActive = (path: string) => route.path === path;

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value;
};

const closeMenu = () => {
  menuOpen.value = false;
};

const handleResize = () => {
  if (window.innerWidth > 900) {
    menuOpen.value = false;
  }
};

// Header scroll effect

onMounted(() => {
  const header = document.querySelector("header");
  window.addEventListener("resize", handleResize);
  window.addEventListener("scroll", () => {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                alt: "Winn Digital logo",
                src: _imports_0,
                class: "logo"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              to: "/",
              class: _normalizeClass(['nav-link', { active: isActive('/') }])
            }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Home", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/services",
              class: _normalizeClass(['nav-link', { active: isActive('/services') }])
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Services", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/about",
              class: _normalizeClass(['nav-link', { active: isActive('/about') }])
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" About", -1)
              ]))]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: _normalizeClass(['nav-link', { active: isActive('/contact') }])
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Contact", -1)
              ]))]),
              _: 1
            }, 8, ["class"])
          ]),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "nav-cta"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("Free Strategy Call", -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "hamburger",
            onClick: toggleMenu,
            "aria-label": "Menu"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass({ open: menuOpen.value })
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass({ open: menuOpen.value })
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass({ open: menuOpen.value })
            }, null, 2)
          ]),
          _createVNode(_Transition, { name: "fade-slide" }, {
            default: _withCtx(() => [
              (menuOpen.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      onClick: closeMenu,
                      to: "/",
                      class: _normalizeClass(['nav-link', { active: isActive('/') }])
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" Home ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      onClick: closeMenu,
                      to: "/services",
                      class: _normalizeClass(['nav-link', { active: isActive('/services') }])
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode(" Services ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      onClick: closeMenu,
                      to: "/about",
                      class: _normalizeClass(['nav-link', { active: isActive('/about') }])
                    }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" About ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      onClick: closeMenu,
                      to: "/contact",
                      class: _normalizeClass(['nav-link', { active: isActive('/contact') }])
                    }, {
                      default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Contact ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_router_link, {
                      to: "/contact",
                      class: "btn-primary mobile-cta"
                    }, {
                      default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                        _createTextVNode(" Free Strategy Call ", -1)
                      ]))]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[13] || (_cache[13] = _createStaticVNode("<div class=\"footer-logo\"><img alt=\"Winn Digital logo\" src=\"" + _imports_0 + "\" class=\"logo\"></div><a href=\"mailto:info@winndigital.com\" class=\"link\">info@winndigital.com</a><br><a href=\"tel:435-429-1141\" class=\"link\">(435) 429-1141</a><p class=\"footer-tagline\"> Custom Web Development, Integrations/ Automations, and Digital Strategy for Businesses. </p><p> Based in Southern Utah - Proudly partnering with businesses in - St. George, Washington, Hurricane, Cedar City, and across the United States. </p>", 6)),
          _createVNode(_component_router_link, { to: "/privacy" }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
              _createTextVNode("Privacy Policy", -1)
            ]))]),
            _: 1
          }),
          _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_router_link, { to: "/terms" }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
              _createTextVNode("Terms & Conditions", -1)
            ]))]),
            _: 1
          }),
          _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
          _cache[16] || (_cache[16] = _createElementVNode("p", { class: "footer-copyright" }, [
            _createTextVNode("© 2026 Winn Digital. "),
            _createElementVNode("br")
          ], -1))
        ])
      ])
    ])
  ], 64))
}
}

})